/** Shared item table headers for quotation, sales order, invoice, and receipt documents. */

export function DocDetailItemTableHead() {
	return (
		<tr>
			<th className="col-item-no">Item No.</th>
			<th className="col-item-desc">Item</th>
			<th className="num col-item-qty">Qty</th>
			<th className="num col-item-rate">Rate</th>
			<th className="num col-item-amount">Amount</th>
		</tr>
	);
}

export function DocEditItemTableHead({
	rateLabel = "Rate",
	showTax = false,
	showActions = false,
}: {
	rateLabel?: string;
	showTax?: boolean;
	showActions?: boolean;
}) {
	return (
		<tr>
			<th className="center col-item-no">Item No.</th>
			<th className="col-item-desc">Item</th>
			<th className="center col-item-qty">Qty</th>
			<th className="num col-item-rate">{rateLabel}</th>
			{showTax ? <th className="num">Tax</th> : null}
			<th className="num col-item-amount">Amount</th>
			{showActions ? <th className="center" aria-label="Remove line" /> : null}
		</tr>
	);
}
